export default {
  flagsList:null,
  patientFlagsList:null,
  latestFlag:null,
  flagsForPatients:null,
}